module.exports = __webpack_public_path__ + "static/img/2elaag.cc22120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2elaag.svg
// module id = oWgc
// module chunks = 0